import {otsBaseApi} from "../../ots-api";
import {
  ActivityPeriod,
  ActivityPeriodSearchCriteria,
  ActivityPeriodSummary,
  ActivityPeriodSummarySource,
} from "../../../model/activity-period"

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ['ActivityPeriods']})

const operatorActivityPeriodApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchOperatorActivityPeriods: builder.query<
      ActivityPeriod[],
      ActivityPeriodSearchCriteria
    >({
      query: (criteria) => ({
        url: '/activity-period/operator/searchcriteria',
        method: 'POST',
        body: criteria,
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(
              ({id}) => ({type: 'ActivityPeriods', id} as const)
            ),
            {type: 'ActivityPeriods', id: 'LIST'},
          ];
        } else {
          return [{type: 'ActivityPeriods', id: 'LIST'}];
        }
      },
    }),
    getOperatorActivityPeriod: builder.query<
      ActivityPeriod,
      string
    >({
      query: (arg) => ({
        url: `/activity-period/operator/${arg}`,
        method: 'GET',
      }),
      providesTags: (result) => {
        if (result) {
          return [
            {type: 'ActivityPeriods', id: result.id},
            {type: 'ActivityPeriods', id: 'LIST'},
          ];
        } else {
          return [{type: 'ActivityPeriods', id: 'LIST'}];
        }
      },
    }),
    getActivityPeriodSummary: builder.query<
      ActivityPeriodSummary,
      {id: string; source?: ActivityPeriodSummarySource; tenantCode?: string}
    >({
      query: ({id, source = 'ROLLUP', tenantCode}) => ({
        url: `/activity-period/${id}/summary`,
        method: 'GET',
        params: {source, tenantCode},
      }),
      providesTags: (_result, _error, {id}) => [
        {type: 'ActivityPeriods', id: `SUMMARY-${id}`},
      ],
    }),
    refreshActivityPeriodSummary: builder.mutation<
      ActivityPeriodSummary,
      {id: string; tenantCode?: string}
    >({
      query: ({id, tenantCode}) => ({
        url: `/activity-period/${id}/summary/refresh`,
        method: 'POST',
        params: {tenantCode},
      }),
      invalidatesTags: (_result, _error, {id}) => [
        {type: 'ActivityPeriods', id: `SUMMARY-${id}`},
      ],
    }),
  }),
})

export const {
  useSearchOperatorActivityPeriodsQuery,
  useGetOperatorActivityPeriodQuery,
  useGetActivityPeriodSummaryQuery,
  useRefreshActivityPeriodSummaryMutation,
} = operatorActivityPeriodApi;
